/**
 *
 * @param {String} input
 * @returns {String}
 */
const getSelector = (input) => {
  if (input.startsWith("attribute(")) {
    return `[${input.slice(10, -1)}]`;
  } else {
    return input;
  }
}

export default getSelector;